// extracted by mini-css-extract-plugin
export default {"delete-button":"delete_delete-button__P+ElJ","delete-button__icon":"delete_delete-button__icon__zWX22"};